import { useEffect, useState } from "react"
import { BarcodeType, IKizBoxDTO, IKizDTO, IkizDocumentItemGtinDto } from "../../libs/coreapi-dto/dirs/kiz";
import { IDocumentInfoDTO } from "../../libs/coreapi-dto/@types/common";
import { KizDataProvider } from "../../Services/DataProviders/KizDataProvider";
import { useAppContext } from "../../system/providers/appContextProvider";
import buffer from "buffer";
import renderGlobalAlert from "../../system/hooks/useGlobalAlert";
import { DocumentType, IdTableVariant, SysOptionName } from "../../@types/enumsGlobal";
import { validateDuplicateKizs } from "../../system/functions/validateDuplicateKizs";
import { IBaseDocumentItemKizDTO } from "../../libs/coreapi-dto/documents/base";
import { cyrillicKeyboardTranslation } from "../../system/functions/keyboardLanguageTranslation";
import { SysOptionsDataProvider } from "../../Services/DataProviders/SysOptionsDataProvider";
import { NIL as uuidNull,  v4 as uuidv4,} from 'uuid';
import { KizParsed } from "../../Business/Dictionaries/Kiz/KizParsed";
import { ISysOptionsDTO, SysOptionsNamesDto } from "../../libs/coreapi-dto/service/sysOptions";
import { useTranslation } from "react-i18next";

export const useItemsByGtin = (_idTable: IdTableVariant, _documentType: DocumentType) =>
{
    const appContext = useAppContext();

    const kizDP = new KizDataProvider(appContext.coreApiService);
    const sysOptionsDataProvider = new SysOptionsDataProvider(appContext.coreApiService)
    
    const { t } = useTranslation();
    const errorsT = (value: string) => t("errors." + value);
    
    const idTable = _idTable
    const documentType = _documentType
    const [showModalItems, setShowModalItems] = useState(false)
    const [isSysOptionLs,setIsSysOptionLs] = useState<boolean>(false)
    const [isPieceAccountingKizOsu, setIsPieceAccountingKizOsu] = useState<boolean>()

    const [kizIdDocumentByGtin,setKizIdDocumentByGtin] = useState<IkizDocumentItemGtinDto>();
    const gtin = kizIdDocumentByGtin?.kizParsedDto?.kizData?.gtin ?? kizIdDocumentByGtin?.kizParsedDto?.kizBoxData?.gtin ?? kizIdDocumentByGtin?.kizParsedDto?.kizOsuData?.gtin ?? ''
    const scan = kizIdDocumentByGtin?.kizParsedDto?.kizData?.barcode ?? kizIdDocumentByGtin?.kizParsedDto?.kizBoxData?.barcode ?? kizIdDocumentByGtin?.kizParsedDto?.kizOsuData?.barcode ?? ''

    useEffect(() => {
        const dto: SysOptionsNamesDto = {
                    sysOptionsNames: [
                        SysOptionName.InvoiceIsLs, 
                        SysOptionName.IndividualInventoryOfGoodsGISMT
                    ]
                };
        
                const handleOptionsResponse = (options: ISysOptionsDTO[]) => {
                    const invoiceIsLs = options.find(opt => opt.name === SysOptionName.InvoiceIsLs);
                    const individualInventory = options.find(
                        opt => opt.name === SysOptionName.IndividualInventoryOfGoodsGISMT
                    );
        
                    setIsSysOptionLs(invoiceIsLs?.value.toLowerCase() === 'true');
                    setIsPieceAccountingKizOsu(individualInventory?.value.toLowerCase() === 'true');
                };
        
                const handleOptionsError = () => {
                    console.error(errorsT("systemSettingsLoadError"));
                };
        
                sysOptionsDataProvider.getByNames(dto, (data) => {
                    if (data && data.length > 0) {
                        handleOptionsResponse(data);
                    } else {
                        handleOptionsError();
                    }
                });
    },[])

    const definitionKizScan = (item: IBaseDocumentItemKizDTO, data:IkizDocumentItemGtinDto) => {
        if (data.kizParsedDto.barcodeType === BarcodeType.KizBox) return BarcodeType.KizBox
        if (data.kizParsedDto.barcodeType === BarcodeType.kizOsu) return BarcodeType.kizOsu
        if (!isSysOptionLs) return BarcodeType.Kiz
        if (item.isLs) return BarcodeType.Kiz
        return BarcodeType.kizOsu
    }

    function getKiz(data:IkizDocumentItemGtinDto,documentItems: IBaseDocumentItemKizDTO[], idGlobal: string) {
        let item = documentItems.find(c => c.idGlobal === idGlobal)
        if (!item) {
            renderGlobalAlert({ variant: "exception", statusCode: 500, title: `${errorsT("notFoundLotByGtin")} ${gtin}` });
            return;
        } 

        if (!(item.isKiz || item.isKizBox)) {
            renderGlobalAlert({ variant: "exception", statusCode: 500, title: errorsT("lotIsNotKiz") });
            return;
        }

        const barcodeType = definitionKizScan(item,data)
        //Киз определен как Kiz и признак товара лекарственное средство
        if (barcodeType === BarcodeType.Kiz) {
            
            if (item.quantity === item.kizs?.length) {
                renderGlobalAlert({ variant: "exception", statusCode: 500, title: errorsT("maxKizInLotExceeded") });
                return;
            }

            const kiz = data.kizParsedDto.kizData
            item = {
                ...item,
                kizs: [
                    ...(item?.kizs || []),
                    {
                        barcode: kiz.barcode,
                        decodedBarcode: kiz.decodedBarcode,
                        gtin: kiz.gtin,
                        gtinSGtin: kiz.gtinSGtin,
                        sGtin: kiz.sGtin,
                        isTrusted: kiz.isTrusted,
                        idGlobal: uuidv4()
                    } as IKizDTO
                    ]
                };
                return item

        }

        if (barcodeType === BarcodeType.kizOsu) {

            if (item.quantity === item.kizs?.length) {
                renderGlobalAlert({ variant: "exception", statusCode: 500, title: errorsT("maxKizInLotExceeded") });
                return;
            }

            if (isPieceAccountingKizOsu) {
                item = {
                ...item,
                kizOsuDtos: [
                    ...(item?.kizOsuDtos || []),
                    {
                        barcode: data?.kizParsedDto?.kizData?.barcode ?? data?.kizParsedDto.kizOsuData.barcode,
                        decodedBarcode: data?.kizParsedDto?.kizData?.decodedBarcode ?? data?.kizParsedDto.kizOsuData.decodedBarcode,
                        gtin: data?.kizParsedDto?.kizData?.gtin ?? data?.kizParsedDto?.kizOsuData.gtin,
                        gtinSGtin: data?.kizParsedDto?.kizData?.gtinSGtin ?? data?.kizParsedDto?.kizOsuData?.gtinSGtin,
                        sGtin: data?.kizParsedDto?.kizData?.sGtin ?? data?.kizParsedDto?.kizOsuData?.sGtin,
                        idGlobal: uuidv4()
                    } as IKizDTO
                    ]
                };
            }
            else {
                item = {...item, kizOsuDto: {
                    barcode: data?.kizParsedDto?.kizData?.barcode ?? data?.kizParsedDto.kizOsuData.barcode,
                    gtin: data?.kizParsedDto?.kizData?.gtin ?? data?.kizParsedDto?.kizOsuData.gtin,
                    gtinSGtin: data?.kizParsedDto?.kizData?.gtinSGtin ?? data?.kizParsedDto?.kizOsuData?.gtinSGtin,
                    sGtin: data?.kizParsedDto?.kizData?.sGtin ?? data?.kizParsedDto?.kizOsuData?.sGtin,
                    idDocumentItem: item.idGlobal
                }}
            }
            
            return item
        } 

        if (barcodeType === BarcodeType.KizBox) {
            const kizBox = data.kizParsedDto.kizBoxData
            item?.kizBoxes?.push({
                sscc: kizBox.sscc,
                quantity: 1,
                barcode: kizBox.barcode,
                idGlobal:  uuidv4()
            } as IKizBoxDTO)
            return item
        }
        return;
    }   

    return {
        getItems: (barcode: string, idGlobal: string) =>
        {
            barcode = cyrillicKeyboardTranslation(barcode)
            const scanDataBase64: string = buffer.Buffer.from(barcode, "ascii").toString("base64");

            if (scanDataBase64.length > 150) {
                renderGlobalAlert({ variant: "error", statusCode: 500, title: errorsT("kizLength") });
                return;
            }

            kizDP.getIdDocumentItemByGtin(scanDataBase64, { idDocument: idGlobal, idTable: idTable } as IDocumentInfoDTO, uuidNull , (e) => {
                setKizIdDocumentByGtin(e)
            }, (response) => {
                renderGlobalAlert({ variant: "exception", statusCode: 500, title: `${errorsT("errorFindByGtin")}. ${response?.message?.title}`, detail: response?.message?.detail});
            })
        },
        allowKiz: (documentItems: IBaseDocumentItemKizDTO[], displayItems: any[],
             callback?:(e: IBaseDocumentItemKizDTO | undefined) => void,
             onDuplicateKiz?: (idGlobal: string, scan: string) => void
             ) => {
        
            if (!kizIdDocumentByGtin) {
                renderGlobalAlert({
                    variant: "exception",
                    title: errorsT("kizIdDocumentEmptyError"),
                    statusCode: 500,
                });
                return
            }

            if (kizIdDocumentByGtin.idDocumentItemsGlobal?.length > 0) {
                if(!validateDuplicateKizs(documentItems,scan as string,documentType)) {

                    let _scan =  KizParsed.decodedBarcode(scan)
                    var kizParsed = new KizParsed(_scan)

                    const item = documentItems.find((x) => {
                        let kizResult = x.kizs?.find(c => c.gtinSGtin === kizParsed.gtinSgtin)
                        let kizOsuResult = x.kizOsuDto?.gtinSGtin === kizParsed.gtinSgtin
                        let kizOsuDtosResult = x.kizOsuDtos?.find(c => c.gtinSGtin === kizParsed.gtinSgtin)
                        let kizBoxResult = x.kizBoxes?.find(c => c.barcode === scan)
                        let kizBoxGisMtResult = x.kizBoxesGisMt?.find(c => c.barcode === scan)
                        return kizResult || kizOsuResult || kizOsuDtosResult || kizBoxResult || kizBoxGisMtResult
                    })
                    
                    const goodsName = displayItems.find(x => x.idGlobal === item?.idGlobal)?.goodsName

                    if (onDuplicateKiz && item?.idGlobal) {
                        renderGlobalAlert({
                            variant: "exception",
                            title: `${errorsT("kizScannedInDocument")}" ${goodsName} ",  ${scan}`,
                            statusCode: 500,
                        });
                        onDuplicateKiz(item.idGlobal, scan);
                        return;
                    }

                    renderGlobalAlert({
                        variant: "exception",
                        title: `${errorsT("kizScannedInDocument")}" ${goodsName} ",  ${scan}`,
                        statusCode: 500,
                    },true);
                    return;
                }
            }

            if (kizIdDocumentByGtin.idDocumentItemsGlobal?.length === 1) {
                let item = getKiz(kizIdDocumentByGtin,documentItems,kizIdDocumentByGtin.idDocumentItemsGlobal[0])
                callback?.(item)
                return
            } 

            if (kizIdDocumentByGtin.idDocumentItemsGlobal?.length >= 1) {
                setShowModalItems(true)
                return
            }

            renderGlobalAlert({
                variant: "exception",
                title: `${errorsT("noBatchesWithGtinInDocument")} ${gtin}`,
                statusCode: 500,
            });
        },
        getKiz:(idGlobal: string, documentItems: IBaseDocumentItemKizDTO[], callback:(e: IBaseDocumentItemKizDTO | undefined) => void) => {
            if (!kizIdDocumentByGtin) return
            callback(getKiz(kizIdDocumentByGtin,documentItems,idGlobal))
        },
        isShowModal: () => {
            return showModalItems
        },
        setShowModal: (bool: boolean) => {
            setShowModalItems(bool)
        },
        getKizIdItemsByGtin: () => {
            return kizIdDocumentByGtin
        },
        setKizIdItemsByGtin: (data?: IkizDocumentItemGtinDto) => {
            setKizIdDocumentByGtin(data)
        }
    }
}

export default useItemsByGtin
